import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { ACECodeEditor, Editors } from "../../../Constant";
import JavascriptMode from "./JavascriptMode";
import HtmlMode from "./HtmlMode";
import CssMode from "./CssMode";
import JavaMode from "./JavaMode";

const AceCodeEditorsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={ACECodeEditor} parent={Editors} title={ACECodeEditor} />
      <Container fluid>
        <Row>
          <JavascriptMode/>
          <HtmlMode/>
          <CssMode/>
          <JavaMode/>
        </Row>
      </Container>
    </>
  );
};

export default AceCodeEditorsContainer;
